/**
 * @prettier
 * @flow
 */
import _isString from 'lodash/isString';

export const isString = _isString;
